import { ReplaySubject, Observable } from "rxjs";
import { Doctor } from "@biorec/partners/domain";
import { Injectable } from "@angular/core";
import { CurrentDoctorDocument, CurrentDoctorUpdateDocument } from "@biorec/partners/gql";
import { DoctorDtoInput } from "@biorec/partners/domain";
import { GraphQLClient } from "@biorec/common";
import { map, share } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class DoctorsServiceGql {


	private currentDoctor: ReplaySubject<Doctor> = new ReplaySubject(1);

	get currentDoctor$() {
		return this.currentDoctor.asObservable();
	}

	constructor(private client: GraphQLClient) {
		this.getCurrent();
	}

	private getCurrent(): Observable<Doctor> {
		const o = this.client.request(CurrentDoctorDocument)
			.pipe(map(result => result.Doctor as Doctor), share());
		o.subscribe(doctor => this.currentDoctor.next(doctor));
		return o;
	}

	updateDoctor(changedDoc: DoctorDtoInput): Observable<Doctor> {
		const o = this.client.request(CurrentDoctorUpdateDocument, { doc: changedDoc })
			.pipe(map(response => response.DoctorUpdate as Doctor), share());
		o.subscribe(doctor => this.getCurrent());
		return o;
	}
}
